import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderTracking', {
  openModal: 'Sigue tu pedido'
});
